import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const Printer24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M18 16h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1v-5h12v5ZM6 6V2h12v4h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4H6v-4H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1Zm2 14h8v-7H8v7ZM8 6h8V4H8v2Z' /></svg>);
